import React from 'react';
import Svg from '../Svg';

const IconAcademic = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 12C1 6.51306 5.29268 2 10.6667 2C12.4333 2 14.0905 2.49112 15.5149 3.34682C15.9884 3.63122 16.1416 4.24556 15.8572 4.71899C15.5728 5.19242 14.9585 5.34566 14.4851 5.06126C13.36 4.38543 12.0572 4 10.6667 4C6.46772 4 3 7.54581 3 12C3 16.4542 6.46772 20 10.6667 20C12.0572 20 13.36 19.6146 14.4851 18.9387C14.9585 18.6543 15.5728 18.8076 15.8572 19.281C16.1416 19.7544 15.9884 20.3688 15.5149 20.6532C14.0905 21.5089 12.4333 22 10.6667 22C5.29268 22 1 17.4869 1 12ZM17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L18.7071 16.7071C18.3166 17.0976 17.6834 17.0976 17.2929 16.7071C16.9024 16.3166 16.9024 15.6834 17.2929 15.2929L19.5858 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H19.5858L17.2929 8.70711C16.9024 8.31658 16.9024 7.68342 17.2929 7.29289Z"
    />
  </Svg>
);

export default IconAcademic;
